import React, { Component, Fragment } from "react";
import FlexView from "react-flexview";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import M from "moment";
import * as R from "ramda";
import {
  flattenFormGroupObject,
  getValueFromDDL,
  removeNullFields,
} from "../../../common/mapper";
import { defaultTableChange } from "../../../../modules/custom/customTable";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import { formGroupOnSubmission, initialData, tableColumns } from "./config";
import OnSubmissionFilter from "./onSubmissionFilter";
import OnSubmissionModifying from "./onSubmissionModifying";
import Api from "../../../../Services/Api";
import { ACTIVITY_TYPE, HttpStatus } from "../../../common/Constants";
import { fetchDataAsync } from "../../../../Services/Utils";

class OnSubmission extends Component {
  constructor(props) {
    super(props);
    this.initialDate = {
      startDateSubmission: M(new Date()).format("DD-MM-YYYY"),
      endDateSubmission: M(new Date()).format("DD-MM-YYYY"),
    };
    this.state = {
      loading: false,
      filterModalVisible: false,
      modifyingModalVisible: false,
      action: null,
      tableColumns: [
        ...tableColumns.firstPage,
        {
          name: "realisasi",
          label: "Action",
          options: {
            customBodyRender: (val, tableMeta) => {
              return (
                <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                  <SimpleButton
                    category="action_button"
                    style={{ backgroundColor: "transparent" }}
                    icon={
                      <i
                        style={{ fontSize: 20, color: "red" }}
                        className="fa fa-lg fa-eye"
                      />
                    }
                    onClick={() =>
                      this.handleModifyingModalVisibility(
                        tableMeta.rowIndex,
                        "view",
                      )
                    }
                  />
                  {!val && (
                    <SimpleButton
                      category="action_button"
                      style={{ backgroundColor: "transparent" }}
                      icon={
                        <i
                          style={{ fontSize: 20, color: "red" }}
                          className="fa fa-lw fa-pencil-alt"
                        />
                      }
                      onClick={() =>
                        this.handleModifyingModalVisibility(
                          tableMeta.rowIndex,
                          "edit",
                        )
                      }
                    />
                  )}
                </FlexView>
              );
            },
            sort: false,
          },
        },
      ],
      search: { ...initialData.search },
      filterData: { ...initialData.filter },
      dataTable: [],
      pagination: {
        count: 0,
        limit: 5,
        page: 1,
        orderBy: "id",
        sort: "ASC",
      },
    };
  }

  componentDidMount = async () => {
    this.handleTriggerLoading();
    await this.setState((prevState) => ({
      ...prevState,
      filterData: { ...prevState.filterData },
      search: {
        ...prevState.search,
        ...this.initialDate,
        kodeCabang: this.props.selectedCabang,
      },
    }));

    await this.fetchData({
      ...removeNullFields(this.parseFilterData(this.state.search)),
      limit: this.state.pagination.limit,
      page: 1,
    });
    this.handleTriggerLoading();
  };

  componentDidUpdate = async (prevProps, prevState) => {
    if (this.props.selectedCabang !== prevProps.selectedCabang) {
      this.handleTriggerLoading();
      this.setState(
        (prevState) => ({
          ...prevState,
          search: { ...this.initialDate },
          filterData: { ...initialData.filter },
        }),
        async () => {
          await this.fetchData({
            ...removeNullFields(this.parseFilterData(this.state.search)),
            kodeCabang: this.props.selectedCabang?.value,
            limit: 5,
            page: 1,
          });
          this.handleTriggerLoading();
        },
      );
    }
  };

  handleModalFilterVisibility = () => {
    this.setState((prevState) => ({
      ...prevState,
      selectedCabang: this.state.search.kodeCabang,
      filterModalVisible: !prevState.filterModalVisible,
    }));
  };

  handleModifyingModalVisibility = (index, action) => {
    this.setState((prevValue) => ({
      ...prevValue,
      selectedData: !R.isNil(index) ? prevValue.dataTable[index] : null,
      modifyingModalVisible: !prevValue.modifyingModalVisible,
      action: action,
    }));
  };

  handleInputDateChange = (name, value) => {
    let parseValue = M(value).format("DD-MM-YYYY");
    if (R.equals("startDate", name)) {
      if (parseValue > this.state.search.endDate) {
        this.setState((prevValue) => ({
          ...prevValue,
          search: {
            ...prevValue.search,
            [name]: parseValue,
            endDate: parseValue,
          },
        }));
        return;
      }
    }

    this.setState((prevValue) => ({
      ...prevValue,
      search: {
        ...prevValue.search,
        [name]: parseValue,
      },
    }));
  };

  handleClearSearch = () => {
    this.setState((prevState) => ({
      ...prevState,
      search: {
        ...prevState.search,
        ...initialData.search,
        kodeCabang: this.props.selectedCabang,
      },
      pagination: {
        count: 0,
        limit: 5,
        page: 1,
      },
    }));
  };

  handleSubmitSearch = async () => {
    this.handleTriggerLoading();
    let requestBody = {
      ...removeNullFields(this.parseFilterData(this.state.search)),
      kodeCabang: this.props.selectedCabang?.value,
      limit: 5,
      page: 1,
    };

    this.handleClearFilter();
    await this.fetchData(requestBody);
    this.handleTriggerLoading();
  };

  handleFilterValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  handleClearFilter = () => {
    this.setState((prevState) => ({
      ...prevState,
      filterData: {
        ...initialData.filter,
      },
    }));
  };

  handleOnSubmitFilter = async () => {
    this.handleTriggerLoading();
    this.setState(
      {
        pagination: {
          limit: 5,
          page: 1,
          totalData: 0,
        },
      },
      async () => {
        let requestBody = {
          ...removeNullFields(this.parseFilterData(this.state.filterData)),
          kodeCabang: this.props.selectedCabang?.value,
          limit: this.state.pagination.limit,
          page: 1,
        };

        console.log("requestBody: ", requestBody);
        this.handleClearSearch();
        await this.fetchData(requestBody);
        this.handleModalFilterVisibility();
        this.handleTriggerLoading();
      },
    );
  };

  refetch = async () => {
    this.handleTriggerLoading();
    const { page, limit } = this.state.pagination;
    const filterRequest = removeNullFields(
      this.parseFilterData(this.state.filterData),
    );
    const searchRequest = removeNullFields(
      this.parseFilterData(this.state.search),
    );
    const paramFilters = !R.isEmpty(filterRequest)
      ? { ...filterRequest }
      : { ...searchRequest };

    const reqBody = {
      ...paramFilters,
      kodeCabang: this.props.selectedCabang?.value,
      page,
      limit,
    };

    await this.fetchData(reqBody);
    this.handleTriggerLoading();
  };

  handleSubmitModifying = async (controls, activityType) => {
    this.handleTriggerLoading();
    const formGroup = flattenFormGroupObject(controls);
    let detail = this.constructDataDetail(controls.dataDetail?.value);

    let requestBody = {
      ...formGroup,
      noBKK: R.equals(activityType, ACTIVITY_TYPE.CREATE)
        ? ""
        : formGroup.noBKK,
      nomorPengajuan: R.equals(activityType, ACTIVITY_TYPE.CREATE)
        ? ""
        : formGroup.nomorPengajuan,
      kodeCabang: this.props.selectedCabang?.value,
      kodeSamsat: getValueFromDDL(formGroup, "kodeSamsat"),
      noSupplier: formGroup.noSupplier?.value || null,
      bbnId: getValueFromDDL(formGroup, "bbnId"),
      dataDetail: detail,
    };

    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").saveSubmission,
      menuName: "Process Samsat",
      setError: this.props.setError,
      args: requestBody,
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.handleModifyingModalVisibility();
      await this.refetch(); 
    }

    this.handleTriggerLoading();
  };

  handleChangePage = async (tableState) => {
    this.handleTriggerLoading();
    let limit = tableState.rowsPerPage;
    let page = tableState.page + 1;
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: page,
        limit: limit,
        count: 0,
      },
    }));

    const filterRequest = removeNullFields(
      this.parseFilterData(this.state.filterData),
    );
    const searchRequest = this.parseFilterData(this.state.search);

    let paramFilters;
    if (!R.isEmpty(filterRequest)) {
      paramFilters = { ...filterRequest };
    } else {
      paramFilters = { ...searchRequest };
    }

    const reqBody = {
      ...paramFilters,
      kodeCabang: this.props.selectedCabang?.value,
      page: page,
      limit: limit,
    };

    await this.fetchData(reqBody);
    this.handleTriggerLoading();
  };

  handleChangeRowsPerPage = async (tableState) => {
    this.handleTriggerLoading();
    let limit = tableState.rowsPerPage;
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        count: 0,
        page: 1,
        limit: limit,
      },
    }));

    const filterRequest = removeNullFields(
      this.parseFilterData(this.state.filterData),
    );
    const searchRequest = removeNullFields(
      this.parseFilterData(this.state.search),
    );

    let paramFilters;
    if (!R.isEmpty(filterRequest)) {
      paramFilters = {
        ...filterRequest,
        kodeCabang: this.state.search.kodeCabang?.value,
      };
    } else {
      paramFilters = {
        ...searchRequest,
        kodeCabang: this.props.selectedCabang?.value,
      };
    }

    const reqBody = {
      ...paramFilters,
      page: 1,
      limit: limit,
    };

    await this.fetchData(reqBody);
    this.handleTriggerLoading();
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  parseFilterData(data) {
    return {
      ...data,
      kodeCabang: getValueFromDDL(data, "kodeCabang"),
    };
  }

  constructDataDetail = (data) => {
    return data.map((item) => {
      return {
        processSamsatId: item.processSamsatId,
        orderH1: item.orderH1,
        salesFakturDate: item.tanggalFakturJual,
        salesFakturNo: item.nomorFakturJual,
        bookNo: item.nomorBuku,
        kodeVarian: item.dataVariant?.kodeVariant,
        idWarna: item.dataWarna?.id,
        stnkName: item.namaSTNK,
        customerName: item.namaPembeli,
        engineNumber: item.nomorMesin,
        frameNumber: item.nomorRangka,
        bbnPrice: R.isNil(item.nominalBBN) ? 0 : item.nominalBBN,
        customerOwnerId: item.customerOwnerId,
        customerOrderId: item.customerOrderId,
      };
    });
  };

  fetchData = async (body) => {
    const { page, limit } = this.state.pagination;

    let req =
      body && Object.keys(body).length > 0
        ? body
        : {
            kodeCabang: this.props.selectedCabang?.value,
            ...removeNullFields(this.parseFilterData(this.state.search)),
            limit,
            page,
          };
    let response = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").findAllOnSubmissionSamsat,
      menuName: "Process Samsat",
      setError: this.props.setError,
      args: req,
    });

    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: response.data.data,
        pagination: {
          ...prevValue.pagination,
          count: response.data.totalData,
          page: req.page,
          limit: req.limit,
        },
      }));
    }
  };

  render() {
    return (
      <>
        <FlexView
          style={{ justifyContent: "space-between" }}
          vAlignContent="center"
        >
          <FlexView vAlignContent="center" style={{ gap: "10px" }}>
            <SimpleDate
              id="select_date_from"
              date={this.state.search.startDateSubmission}
              onChange={(value) =>
                this.handleInputDateChange("startDateSubmission", value)
              }
            />
            <SimpleDate
              id="select_date_to"
              minDate={this.state.search.startDateSubmission}
              date={this.state.search.endDateSubmission}
              onChange={(value) =>
                this.handleInputDateChange("endDateSubmission", value)
              }
            />
            <SimpleButton
              text="Cari"
              className="margin-bottom-15px"
              onClick={this.handleSubmitSearch}
            />
          </FlexView>
          <FlexView
            vAlignContent="center"
            hAlignContent="right"
            style={{ marginBottom: "20px" }}
          >
            <SimpleButton
              className={"btn background-red margin-top-5px"}
              styles={{ width: "unset" }}
              onClick={this.handleModalFilterVisibility}
              icon={<i className="fa fa-qrcode"></i>}
            />
          </FlexView>
        </FlexView>

        <SimpleDataTable
          data={this.state.dataTable}
          columns={this.state.tableColumns}
          toCount={this.state.pagination.count}
          rowsPerPage={this.state.pagination.limit}
          page={this.state.pagination.page - 1}
          options={defaultTableChange(
            (tableState) => this.handleChangePage(tableState),
            (tableState) => this.handleChangeRowsPerPage(tableState),
          )}
          footerAdditionalButtons={
            <SimpleButton
              onClick={() =>
                this.handleModifyingModalVisibility(null, "create")
              }
              icon={<i className="fa fa-plus margin-right-10px"></i>}
              text={"Tambah"}
            />
          }
        />

        {this.state.filterModalVisible && (
          <OnSubmissionFilter
            filterData={this.state.filterData}
            visible={this.state.filterModalVisible}
            onValueChange={this.handleFilterValueChange}
            onSubmit={this.handleOnSubmitFilter}
            onClearForm={this.handleClearFilter}
            onClickClose={this.handleModalFilterVisibility}
          />
        )}

        {this.state.modifyingModalVisible && (
          <OnSubmissionModifying
            {...this.props}
            action={this.state.action}
            formGroup={formGroupOnSubmission}
            initialValues={this.state.selectedData}
            visible={this.state.modifyingModalVisible}
            onSubmit={this.handleSubmitModifying}
            onClickClose={this.handleModifyingModalVisibility}
            triggerLoading={this.handleTriggerLoading}
          />
        )}

        <SimpleLoadingOverlay active={this.state.loading} />
      </>
    );
  }
}

export default OnSubmission;
